module.exports = __webpack_public_path__ + "media/images/access_h3_bg_yokohama-6728aeaf8bd969f52ffe6d76e2922c80.png";